import React from "react";
import { createContext, useReducer, useContext } from "react";

import * as ACTION from "./action";

const AlarmContext = createContext();

const alarmReducer = (state, action) => {
  switch (action.type) {
    case ACTION.UPDATE: {
      return {
        ...state,
        task: null,
        action: {
          reload: true,
        },
      };
    }
    case ACTION.UPDATED: {
      return {
        ...state,
        task: {
          onSiteServiceWorksheet: action.onSiteServiceWorksheet,
          notApproveonSiteServiceWorksheetTask:
            action.notApproveonSiteServiceWorksheetTask,
          servicewWorksheet: action.servicewWorksheet,
          email: action.email,
        },
        action: {
          reload: false,
        },
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};

export const AlarmProvider = ({ children }) => {
  const [state, dispatch] = useReducer(alarmReducer, {
    task: null,
    action: {
      reload: true,
    },
  });
  const value = { state, dispatch };

  return (
    <AlarmContext.Provider value={value}>{children}</AlarmContext.Provider>
  );
};

export const useAlarm = () => {
  const context = useContext(AlarmContext);
  if (context === undefined) {
    throw new Error("useAlarm must be used within a AlarmProvider");
  }
  return context;
};
